/* eslint-disable sort-keys */
// Breakpoints
const breakpoints = {
  // 360px
  mobile: '22.5rem',

  // 480px
  mobileWide: '30rem',

  // 650px
  tablet: '40.625rem',

  // 768px
  tabletWide: '48rem',

  // 1380px
  smallLaptop: '86.25rem',

  // 980px
  desktop: '61.25rem',

  // 1180px
  desktopWide: '73.75rem',

  // 1440px
  desktopExtraMax: '90rem',

  // 1200px
  desktopMax: '75rem',

  // 1600px
  desktopExtraWide: '100rem',

  // 1920px
  fullHd: '120rem',
};

export default breakpoints;
